<div data-cy="email-info-container" class="email-info-container">
  <div class="main-content" data-cy="email-info-main-content">
    <span
      data-cy="email-info-message"
      [innerHTML]="
        'i18n.requestCredit.emailPopoverMessage' | translate: { platformType }
      "
    >
    </span>
  </div>
</div>
